import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { RxJsBridge } from '@trustedshops/tswp-core-common-eventing-rxjs';
import {
  OrganizationalContainer,
  OrganizationalContainerSelectionService,
  TOKENS as TOKENS_MASTERDATA,
} from '@trustedshops/tswp-core-masterdata';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'channel-management',
  templateUrl: 'channel-management.component.html',
  styleUrls: ['channel-management.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false,
})
export class ChannelManagementComponent {
  //#region Static Fields
  public static readonly selector: string =
    'tswp-carrier-b2b-channel-management';
  //#endregion

  //#region Properties
  private readonly _channels: Observable<OrganizationalContainer<any>[]>;
  public get channels(): Observable<OrganizationalContainer<any>[]> {
    return this._channels;
  }

  private readonly _selectedChannels: Observable<
    OrganizationalContainer<any>[]
  >;
  public get selectedChannels(): Observable<OrganizationalContainer<any>[]> {
    return this._selectedChannels;
  }
  //#endregion

  //#region Ctor
  public constructor(
    @Inject(TOKENS_MASTERDATA.OrganizationalContainerSelectionService)
    private readonly _organizationalContainerSelector: OrganizationalContainerSelectionService
  ) {
    this._channels = this._organizationalContainerSelector
      .getAllContainers()
      .convertWith(RxJsBridge(BehaviorSubject))
      .pipe(filter<OrganizationalContainer<any>[]>((x) => !!x));

    this._selectedChannels = this._organizationalContainerSelector
      .getSelection()
      .convertWith(RxJsBridge(BehaviorSubject))
      .pipe(filter<OrganizationalContainer<any>[]>((x) => !!x));
  }
  //#endregion

  //#region Public Methods
  public isSelected(
    selection: OrganizationalContainer<any>[],
    channel: OrganizationalContainer<any>
  ): boolean {
    return selection.map((x) => x.id).includes(channel.id);
  }

  public selectChannel(channel: OrganizationalContainer<any>): void {
    this._organizationalContainerSelector.selectContainers([channel]);
  }
  //#endregion
}
